module.exports = __webpack_public_path__ + "f3643900c5453aaeac7386bf28cc051a.ttf";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-light-webfont.ttf
// module id = 312
// module chunks = 0